"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetType = exports.EntityType = void 0;
var EntityType;
(function (EntityType) {
    EntityType["Users"] = "users";
    EntityType["Items"] = "items";
    EntityType["Stores"] = "stores";
    EntityType["Promotions"] = "promotions";
})(EntityType || (exports.EntityType = EntityType = {}));
var AssetType;
(function (AssetType) {
    AssetType["Images"] = "images";
    AssetType["TemporaryVideos"] = "tmp/videos";
    AssetType["Videos"] = "videos";
})(AssetType || (exports.AssetType = AssetType = {}));
//# sourceMappingURL=asset.js.map